<script>
  import {Hooper, Navigation, Pagination, Slide} from 'hooper';

  export default {
    name: 'SWCarousel',
    inheritAttrs: false,
    components: {
      Hooper,
      Slide,
      Pagination,
      Navigation
    },
    props: {
      withNavigation: {
        type: Boolean,
        default: true
      },
      withPagination: {
        type: Boolean,
        default: true
      },
      thumbnailsToShow: {
        type: Number,
        default: 0
      },
      withThumbnailsNavigation: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      currentSlide: 0
    }),
    watch: {
      currentSlide(current) {
        if (this.currentSlide !== current) {
          this.goToSlide(current);
        }
      }
    },
    methods: {
      setCurrentSlide({currentSlide}) {
        this.currentSlide = currentSlide;
      },
      isCurrentSlide(slide) {
        return this.currentSlide === slide;
      },
      goToSlide(index) {
        this.currentSlide = index;
        this.$refs['main'].slideTo(index);

        let thumbIndex = this.$refs['thumbs'].currentSlide;
        if (index < thumbIndex || index > (thumbIndex + this.thumbnailsToShow - 1)) {
          thumbIndex = index;
        }
        this.$refs['thumbs'].slideTo(thumbIndex);
      },
      _renderSlider(h) {
        const slots = Object.keys(this.$slots).map(slot => h('template', {slot}, this.$slots[slot]));

        const attrs = Object.assign({}, this.$attrs);

        const listeners = {};
        const internalListeners = {
          slide: this.setCurrentSlide
        };
        const listenersList = Object.entries(this.$listeners).concat(Object.entries(internalListeners));
        listenersList.forEach(([key, value]) => {
          if (listeners[key]) {
            if (Array.isArray(listeners[key])) {
              listeners[key].push(value);
            } else {
              listeners[key] = [listeners[key], value];
            }
          } else {
            listeners[key] = value;
          }
        });

        const mainSliderData = {
          ref: 'main',
          class: 'sw-carousel-main',
          attrs: attrs,
          on: listeners,
          scopedSlots: this.$scopedSlots,
          props: {
            mouseDrag: false //TODO: fix mousedrag on non-chrome browsers
          }
        };

        if (this.withNavigation) {
          slots.push(h('navigation', {slot: 'hooper-addons'}));
        }
        if (this.withPagination) {
          slots.push(h('pagination', {slot: 'hooper-addons'}));
        }

        return h('hooper', mainSliderData, slots);
      },
      _renderThumbnails(h) {
        const vm = this;
        const thumbsSliderData = {
          ref: 'thumbs',
          class: 'sw-carousel-thumbs',
          props: {
            centerMode: false,
            trimWhiteSpace: true,
            shortDrag: false,
            itemsToShow: this.thumbnailsToShow
          }
        };
        const thumbs = [];
        const slides = this.$slots.default;
        if (slides && slides.length) {
          slides.forEach((slide, index) => {
            if (slide.componentOptions) {
              const thumb = h('slide', {
                props: {index},
                class: {'is-current-thumbnail': vm.isCurrentSlide(index)},
                nativeOn: {
                  click: () => {
                    vm.goToSlide(index);
                  }
                }
              }, slide.componentOptions.children);
              thumbs.push(thumb);
            }
          });
        }
        if (this.withThumbnailsNavigation) {
          thumbs.push(h('navigation', {slot: 'hooper-addons'}));
        }
        return h('hooper', thumbsSliderData, thumbs);
      }
    },
    render: function (h) {
      const sliders = [];

      sliders.push(this._renderSlider(h));

      if (this.thumbnailsToShow > 0) {
        sliders.push(this._renderThumbnails(h));
      }

      return h('div', {class: 'sw-carousel'}, sliders);
    }
  };
</script>
